<template>
  <div class="min-h-screen bg-[#0f1418] text-white">
    <div class="mx-auto max-w-4xl px-4 py-14 text-center">
      <div class="mx-auto mb-6 h-28 w-28 rounded-full border border-white/15 bg-white/5 flex items-center justify-center">
        <svg viewBox="0 0 24 24" class="h-10 w-10 text-emerald-400"><path fill="currentColor" d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
      </div>
      <h1 class="text-4xl md:text-6xl font-extrabold">Thank You</h1>

      <div class="mx-auto mt-6 max-w-2xl rounded-2xl border border-green-200 bg-green-50/90 px-6 py-6 text-center text-green-900">
        <p class="text-lg md:text-2xl font-semibold leading-relaxed">
          Your request has been created. You will be contacted by our representative shortly.
        </p>
        <button @click="$router.push({name:'Home'})"
                class="mt-4 rounded-full border border-green-700 px-6 py-2.5 text-green-900 font-semibold hover:bg-white">
          Go to home
        </button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>